<ng-container>
  <span>Option 1/4</span>

  <div class="row">
    <div class="col-md-12">
      <title
        direction="left"
        [style]="{ 'font-size': '16px', color: '#3376F6' }"
      >
        Étape 01 : montant et durée de l'investissment.
      </title>
      <pr-input-column
        label="Montant à arbitrer chaque mois"
        [derrors]="derrors"
        [isDefault]="false"
      >
        <input
          matInput
          placeholder="Exemple : 200 € / mois"
          formControlName="avOptionInvestissementProgressifMontantArbitrage"
          type="text"
        />
        <i>€/mois</i>
      </pr-input-column>
    </div>
  </div>

  <div class="row mt">
    <div class="col-md-6">
      <pr-input-column
        label="Durée d’existence des arbitrages"
        [derrors]="derrors"
      >
        <mat-select formControlName="avOptionInvestissementProgressifDuree">
          @for (option of monthlyAmountOptions; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </pr-input-column>
    </div>
    <div class="col-md-6">
      <pr-input-column
        label="Indiquer le nombre de mois"
        [derrors]="derrors"
        [isDefault]="false"
        [hidden]="
          form.get('avOptionInvestissementProgressifDuree')?.value !== 'CUSTOM'
        "
      >
        <input
          matInput
          placeholder="Exemple : 9"
          formControlName="avOptionInvestissementProgressifDureeCustom"
          type="text"
        />
        <i>mois</i>
      </pr-input-column>
    </div>
  </div>
</ng-container>
